/* =========================================================
   Testimonials Slider — external script
   Reads its config from data-* attributes on .testi-section,
   so this file needs no per-instance edits and supports
   multiple sliders on the same page.
   ========================================================= */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.testiInitialized === 'true') return;

    var track = root.querySelector('.testi-track');
    var dotsWrap = root.querySelector('.testi-dots');
    var prevBtn = root.querySelector('.testi-prev');
    var nextBtn = root.querySelector('.testi-next');
    if (!track) return;

    var enableSlider = root.dataset.enableSlider !== 'false';
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
    var perViewDesktop = parseInt(root.dataset.perViewDesktop, 10) || 3;
    var perViewMobile = parseInt(root.dataset.perViewMobile, 10) || 1;

    var slides = Array.prototype.slice.call(track.children);
    var index = 0;
    var timer = null;
    var mq = window.matchMedia('(min-width: 750px)');

    function perView() {
      return mq.matches ? perViewDesktop : perViewMobile;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function renderDots() {
      if (!dotsWrap) return;
      var count = maxIndex() + 1;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testi-dot' + (i === index ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', (function (idx) {
          return function () {
            goTo(idx);
            resetAutoplay();
          };
        })(i));
        dotsWrap.appendChild(dot);
      }
    }

    function update() {
      var pct = (100 / perView()) * index;
      track.style.transform = 'translateX(-' + pct + '%)';
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
          d.classList.toggle('active', i === index);
        });
      }
    }

    function goTo(i) {
      index = Math.min(maxIndex(), Math.max(0, i));
      update();
    }

    function next() {
      index = index >= maxIndex() ? 0 : index + 1;
      update();
    }

    function prev() {
      index = index <= 0 ? maxIndex() : index - 1;
      update();
    }

    function startAutoplay() {
      if (!enableSlider || !autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, autoplaySpeed);
    }

    function resetAutoplay() {
      clearInterval(timer);
      startAutoplay();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        resetAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        resetAutoplay();
      });
    }

    function onResize() {
      index = Math.min(index, maxIndex());
      renderDots();
      update();
    }

    window.addEventListener('resize', onResize);
    if (mq.addEventListener) {
      mq.addEventListener('change', onResize);
    } else if (mq.addListener) {
      mq.addListener(onResize);
    }

    renderDots();
    update();
    startAutoplay();

    root.dataset.testiInitialized = 'true';
  }

  function initAll(scope) {
    var context = scope || document;
    var sections = context.classList && context.classList.contains('testi-section')
      ? [context]
      : Array.prototype.slice.call(context.querySelectorAll('.testi-section'));
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Shopify theme editor: re-init when a section is added/re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();